<template>
  <div :class="['progress-tester', 'align-right', 'my-16']">
    <code :class="['mr-16']">{{ $parent.bars[bar] }}%</code>
    <vc-button-group :color="color" @input="input($event)" size="small">
      <vc-button :disabled="currentValue === 0" icon-left="mdi-battery-outline">Make 0%</vc-button>
      <vc-button :disabled="currentValue === 0" name="-10" icon-left="mdi-battery-negative">Subtract 10%</vc-button>
      <vc-button :disabled="currentValue === 100" name="10" icon-left="mdi-battery-positive">Add 10%</vc-button>
      <vc-button :disabled="currentValue === 100" name="100" icon-left="mdi-battery">Make 100%</vc-button>
    </vc-button-group>
  </div>
</template>
<script>
export default {
  name: 'ProgressTester',
  data () {
    return {
      currentValue: 0
    }
  },
  props: {
    bar: {
      type: String,
      required: true
    },
    color: {
      type: String,
      requiredL: false,
      default: 'primary'
    }
  },
  mounted () {
    this.currentValue = this.$parent.bars[this.bar]
  },
  methods: {
    input (event) {
      if (!event) {
        return
      }
      this.$parent.$emit('progress:update', {
        value: parseInt(event[0], 10),
        bar: this.bar
      })
      this.$nextTick(() => {
        this.currentValue = this.$parent.bars[this.bar]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/progress-tester/ProgressTester.vue